export default "__VITE_ASSET__CpoN1TFH__"